interface DriveContentLike {
  content?: unknown;
  markdown?: unknown;
}

export function hasUsableDriveContent(result: DriveContentLike | null | undefined): boolean {
  if (!result || typeof result !== 'object') {
    return false;
  }

  const content = typeof result.content === 'string' ? result.content.trim() : '';
  const markdown = typeof result.markdown === 'string' ? result.markdown.trim() : '';
  return content.length > 0 || markdown.length > 0;
}
